export const SET_CAMERA = 'SET_CAMERA';

export const setCamera = camera => ({
    type: SET_CAMERA,
    payload: camera
});
